/** @module SiteAdmin/DocRevisionStatusRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/locale",
	"csi/xml"
], function(declare,StringRen,locale,xml) {

	return declare(StringRen, {
		/**
		* @Overide
		* Get the Localised Value for the enum
		*/
		_getValue(ctx,h){
			if(ctx.getNode().IsDriveFile){
				return locale.resource(ctx.getNode().DriveUploadStatus);
			}
		},
	});
});